import React from "react";
import Layout from "../../NewComponent/Layout/Layout";
import Styles from "./HomePageStyles.module.css";
import HomeTile from "../../NewComponent/HomeTile/HomeTile";
import { Space } from "antd";
import { homeTilesData, homeTilesData2 } from "../../Constants";
import SearchBar from "../../NewComponent/SearchBar/SearchBar";
import { useSelector } from "react-redux";

export default function HomePage() {
  const userState = useSelector((state) => state.user);
  return (
    <>
      <Layout>
        <div
          style={{
            width: "74%",
            margin: "auto",
            marginTop: "0%",
            marginBottom: "7%",
          }}
        >
          <div>
            <div className={Styles.coloredText}>
              Hello {userState.firstName},
            </div>
            <div className={Styles.coloredText2}>How can I help you today?</div>
          </div>
          <div className="mt-1">
            <SearchBar />
          </div>
          <br />
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
            }}
          >
            {userState.agenticEnabled
              ? homeTilesData.map((tile) => {
                  return <HomeTile data={tile} />;
                })
              : homeTilesData2.map((tile) => {
                  return <HomeTile data={tile} />;
                })}
          </div>
        </div>
      </Layout>
    </>
  );
}
